module.exports = __webpack_public_path__ + "img/membership.4c2600c3.png";